export default function authHeader() {
    let loggedData = JSON.parse(localStorage.getItem('loggedData'));

    if (loggedData && loggedData.token) {
        return {
            'Authorization': 'Bearer ' + loggedData.token,
            'Accept': 'application/json',
        }; // for Spring Boot back-end
        // return { 'x-access-token': user.token };       // for Node.js Express back-end
    } else {
        return {
            'Accept': 'application/json',
        };
    }
}
